import React, { lazy } from 'react';

const ItInfoLedgerPage = lazy(() => import('./ItInfoLedger/ItInfoLedgerPage'));
const ItCredentialsPage = lazy(() => import('./ItCredentials/ItCredentialsPage'));
const DailyReportPage = lazy(() => import('./DailyReport/DailyReportPage'));

export const deptLedgerPageRoutes = [
  { path: '/dept-ledger/it-info', component: ItInfoLedgerPage },
  { path: '/dept-ledger/it-credentials', component: ItCredentialsPage },
  { path: '/dept-ledger/daily-report', component: DailyReportPage }
];

export default deptLedgerPageRoutes;
